import React from 'react'
import { PaginaNode } from '@gql/graphql'
import { PlaceholderReact } from '@components/molecules'
import { ListingHead, Page, StoreLocatorAssistenza } from 'components/organisms'
import styles from './EditorialeTemplate.module.sass'
import { JsonLd, WContainer } from '@components/atoms'

interface Props {
  pagina?: PaginaNode
  mainContent?: any
}

const EditorialeTemplate = (props: Props) => {
  const { pagina = undefined, mainContent = undefined } = props

  return (
    <Page pagina={pagina} item={pagina} className={`${styles.root}`}>
      <main className={styles.main}>
        <ListingHead pagina={pagina} />
        <PlaceholderReact
          contentTypeId={pagina.model}
          objectId={pagina.pk}
          pkey={'main'}
          serverSideContent={mainContent}
        />
        {pagina.chiave === 'cookie-policy' && (
          <WContainer className={styles.cookiebotContainer}>
            <div id="cookie_list" />
          </WContainer>
        )}
        {pagina.chiave === 'centri-assistenza' && <StoreLocatorAssistenza />}
      </main>
      <JsonLd type="organization" />
    </Page>
  )
}

export default EditorialeTemplate
